import { Component, EventEmitter, Output } from '@angular/core';

import { ReloadNotificationAnalytics } from '../../analytics/reload-notification.analytics';

@Component({
  selector: 'rt-reload-notification',
  templateUrl: './reload-notification.component.html',
  styleUrls: ['./reload-notification.component.less'],
})
export class ReloadNotificationComponent {
  @Output() public close$: EventEmitter<void> = new EventEmitter<void>();
  @Output() public reload$: EventEmitter<void> = new EventEmitter<void>();

  constructor(public reloadNotificationAnalytics: ReloadNotificationAnalytics) {
    this.reloadNotificationAnalytics.trackComponentActions('show');
  }
}
